import { createFileRoute } from '@tanstack/react-router';

import { SettingsShell } from '@/features/app-shell';
import {
  NotificationsPage,
  notificationsSearchSchema,
} from '@/features/notifications';
import { FeatureErrorBoundary } from '@/shared/components/FeatureErrorBoundary';

export const Route = createFileRoute('/notifications')({
  // The page's whole view lives in the address (spec 147 FR-002), so Back
  // from a notification's task returns to the same filters.
  validateSearch: notificationsSearchSchema,
  component: NotificationsRoute,
});

/** Every notification, in the personal area beside its settings (spec 147). */
export function NotificationsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SettingsShell>
      <FeatureErrorBoundary>
        <NotificationsPage
          search={search}
          onSearchChange={(next) => {
            // Replaced, not pushed: Back leaves the page, to wherever was
            // before it, rather than stepping through every filter tried.
            void navigate({ search: next, replace: true });
          }}
        />
      </FeatureErrorBoundary>
    </SettingsShell>
  );
}
